const mapMarkers = document.querySelectorAll('.mapMarker');
const experienceBlocks = document.querySelectorAll('.experienceBlock');

if (mapMarkers) {
	mapMarkers.forEach( (item) => {
		item.addEventListener('click', () => {
			// reset experience blocks
			experienceBlocks.forEach( (item) => {
				item.classList.remove('is-active');
			})

			//reset map markers
			mapMarkers.forEach( (item) => {
				item.classList.remove('is-active');
			})

			// get experience
			let expData = item.dataset.experience;

			// add active class to chosen marker
			item.classList.toggle('is-active');

			// add active class to experience block
			document.getElementById(expData).classList.add('is-active');
		})
	})
}